// extracted by mini-css-extract-plugin
export var completionBody = "_f4-2";
export var completionCard = "_f4-0";
export var completionFooter = "_f4-3";
export var completionTitle = "_f4-1";